  <div class="message-text" [innerHtml]="message | async"></div>